import multiguard from "vue-router-multiguard";
import Guard from "@/router/middleware";

const AccountSetupLayout = () => import("@/components/account-setup/Layout.vue");


const FinalizeAbout = () => import("@/components/account-setup/About.vue");
const FinalizeSocial = () => import("@/components/account-setup/Social.vue");
const FinalizeComplete = () => import("@/components/account-setup/Complete.vue");

const ChangeLog = () => import("@/components/general/ChangeLog.vue");
const Metrics = () => import("@/components/general/Metrics.vue");

// import MediaPreview from "@/components/media-preview/Preview.vue";
// import MediaPreviewV2 from "@/components/media-preview/PreviewV2.vue";
const MediaPreview = () => import("@/components/media-preview/Preview.vue");
const MediaPreviewV2 = () => import("@/components/media-preview/PreviewV2.vue");

export default [
  {
    path: "/",
    name: "DashboardRedirect",
    redirect: "/dashboard",
    beforeEnter: multiguard([
      Guard.auth,
      Guard.verifyUserNotSuspended,
      Guard.verifyUserAcceptedTerms
    ])
  },
  {
    path: "/dashboard",
    name: "DashboardRedirect",
    beforeEnter: multiguard([
      Guard.auth,
      Guard.goToDashboard,
      Guard.verifyUserAcceptedTerms
    ])
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/screens/auth/Login.vue"),
    beforeEnter: multiguard([Guard.preventLoginAccessIfLoggedIn])
  },
  {
    path: "/password/reset",
    name: "PasswordReset",
    component: () => import("@/screens/auth/PasswordReset.vue"),
    beforeEnter: multiguard([Guard.preventLoginAccessIfLoggedIn])
  },
  {
    path: "/password/reset/:token",
    name: "PasswordResetFinal",
    component: () => import("@/screens/auth/PasswordResetFinal.vue"),
    beforeEnter: multiguard([Guard.preventLoginAccessIfLoggedIn])
  },
  {
    path: "/stringer",
    component: () => import("@/screens/stringer/Layout.vue"),
    redirect: "/stringer/home", // to prevent user from landing on blank page
    beforeEnter: multiguard([
      Guard.auth,
      Guard.checkPermissionsVideographer,
      Guard.verifyUserNotSuspended,
      Guard.verifyUserAcceptedTerms
    ]),
    children: [
      {
        path: "dashboard",
        redirect: "stringer/home"
      },
      {
        path: "home",
        name: "StringerHome",
        component: () => import("@/screens/stringer/Home.vue")
      },
      {
        path: "kb",
        name: "StringerKnowledgeBase",
        component: () => import("@/screens/stringer/KnowledgeBase.vue")
      },
      {
        path: "upload",
        name: "StringerUpload",
        component: () => import("@/screens/stringer/Upload.vue")
      },
      {
        path: "announcements",
        name: "StringerAnnouncements",
        component: () => import("@/screens/stringer/Announcements.vue")
      },
      {
        path: "announcements/:uuid",
        name: "StringerAnnouncementView",
        component: () => import("@/screens/stringer/AnnouncementView.vue")
      },
      {
        path: "videos",
        name: "StringerVideos",
        component: () => import("@/screens/stringer/Videos.vue")
      },
      {
        path: "sales",
        name: "StringerVideoSales",
        component: () => import("@/screens/stringer/sales/VideoSales.vue")
      },
      {
        path: "sales/stream",
        name: "StringerStreamSales",
        component: () => import("@/screens/stringer/sales/StreamSales.vue")
      },
      {
        path: "social-income",
        name: "StringerSocialIncome",
        component: () => import("@/screens/stringer/social-income/Main.vue")
      },
      {
        path: "social-income/:granularityId/:reportId",
        name: "StringerSocialIncomeReport",
        component: () => import("@/screens/stringer/social-income/Report.vue")
      },
      {
        path: "settings",
        name: "StringerSettings",
        redirect: "settings/profile",
        component: () => import("@/screens/stringer/settings/Layout.vue"),
        children: [
          {
            path: "profile",
            name: "SettingsProfile",
            component: () => import("@/screens/stringer/settings/Profile.vue")
          },
          {
            path: "password",
            name: "SettingsPassword",
            component: () => import("@/screens/stringer/settings/Password.vue")
          },
          {
            path: "faa",
            name: "SettingsFaa",
            component: () => import("@/screens/stringer/settings/Faa.vue")
          },
          {
            path: "contracts",
            name: "SettingsContracts",
            component: () => import("@/screens/stringer/settings/Contracts.vue")
          },
          {
            path: "notifications",
            name: "SettingsNotifications",
            component: () =>
              import("@/screens/stringer/settings/Notification.vue")
          }
        ]
      },
      {
        path: "support",
        name: "StringerSupport",
        redirect: "support/tickets"
      },
      {
        path: "support/tickets",
        name: "StringerSupportTickets",
        component: () => import("@/screens/stringer/support/Tickets.vue")
      },
      {
        path: "support/tickets/new",
        name: "StringerSupportCreateTicket",
        component: () => import("@/screens/stringer/support/CreateTicket.vue")
      },
      {
        path: "support/tickets/:id", // id = video id
        name: "StringerSupportViewTicket",
        component: () => import("@/screens/stringer/support/ViewTicket.vue")
      },
      {
        path: "socialteam/latest",
        name: "StringerSocialMediaLatestContent",
        component: () => import("@/screens/stringer/socialmedia/Latest.vue"),
        beforeEnter: multiguard([Guard.checkRoleSocialMedia])
      },
      {
        path: "content-requests",
        name: "StringerContentRequests",
        component: () => import("@/screens/stringer/content-requests/Main.vue")
      },
      {
        path: "contnet-requests/:id",
        name: "StringerContentRequest",
        component: () => import("@/screens/stringer/content-requests/Request.vue")
      },
    ]
  },
  {
    path: "/admin",
    component: () => import("@/screens/admin/Layout.vue"),
    redirect: "/admin/dashboard", // to prevent user from landing on blank page
    beforeEnter: multiguard([
      Guard.auth,
      Guard.checkPermissionsAdministrator,
      Guard.verifyUserNotSuspended,
      Guard.verifyUserAcceptedTerms
    ]),
    children: [
      {
        path: "dashboard",
        name: "AdminHome",
        component: () => import("@/screens/admin/Home.vue")
      },
      {
        path: "video-manager",
        name: "AdminVideoManager",
        component: () => import("@/screens/admin/Videos.vue")
      },
      {
        path: "credit-management",
        name: "AdminCreditManagement",
        component: () => import("@/screens/admin/credit-management/Main.vue"),
        beforeEnter: multiguard([
          Guard.checkPermissionsOwner,
        ]),
      },
      {
        path: "credit-management/:id",
        name: "AdminCreditAgreementInfo",
        component: () => import("@/screens/admin/credit-management/AgreementInfo.vue"),
        beforeEnter: multiguard([
          Guard.checkPermissionsOwner,
        ]),
      },
      {
        path: "youtube-statistics",
        name: "AdminYoutubeStatistics",
        component: () => import("@/screens/admin/youtube-statistics/Main.vue"),
        beforeEnter: multiguard([
          Guard.checkPermissionsOwner,
        ]),
      },
      {
        path: "youtube-statistics/:granularity_id",
        name: "AdminYoutubeStatisticsReport",
        component: () => import("@/screens/admin/youtube-statistics/Report.vue"),
        beforeEnter: multiguard([
          Guard.checkPermissionsOwner,
        ]),
      },
      {
        path: "users",
        name: "AdminUsers",
        component: () => import("@/screens/admin/Users.vue")
      },
      {
        path: "users/:uid",
        name: "AdminUserInformation",
        component: () => import("@/screens/admin/users/Layout.vue"),
        redirect: "users/:uid/overview",
        children: [
          {
            name: "AdminUserOverview",
            path: "overview",
            component: () => import("@/screens/admin/users/Overview.vue")
          },
          {
            name: "AdminUserVideos",
            path: "videos",
            component: () => import("@/screens/admin/users/Videos.vue")
          },
          {
            name: "AdminUser",
            path: "sales",
            component: () => import("@/screens/admin/users/Sales.vue")
          }
        ]
      },
      {
        path: "networks",
        name: "AdminNetworks",
        component: () => import("@/screens/admin/Networks.vue")
      },
      {
        path: "networks/:id",
        name: "AdminNetworkView",
        component: () => import("@/screens/admin/networks/Network.vue")
      },
      {
        path: "network-requests",
        name: "AdminNetworkRequests",
        component: () => import("@/screens/admin/network-requests/Main.vue")
      },
      {
        path: "network-requests/:id",
        name: "AdminNetworkRequest",
        component: () => import("@/screens/admin/network-requests/Request.vue")
      },

      // need to finish these
      {
        path: "tools/announcements",
        name: "AdminAnnouncements",
        component: () => import("@/components/admin/tools/Announcements.vue")
      },
      {
        path: "tools/announcements/:id",
        name: "AdminAnnouncement",
        component: () => import("@/components/admin/tools/Announcement.vue")
      },
      {
        path: "tools/mail/errors",
        name: "AdminToolsMailErrors",
        component: () => import("@/screens/admin/tools/MailErrors.vue")
      },
      {
        path: "tools/mail/list",
        name: "AdminToolsMailList",
        component: () => import("@/screens/admin/tools/MailList.vue")
      },
      {
        path: "tools/mail/:id",
        name: "AdminToolsMailItem",
        component: () => import("@/screens/admin/tools/IndividualMail.vue")
      },
      {
        path: "sales",
        name: "AdminSalesLayout",
        redirect: "sales/videos",
        component: () => import("@/screens/admin/sales/Layout.vue"),
        children: [
          {
            path: "videos",
            name: "AdminVideoSalesLayout",
            redirect: "sales/videos/pending",
            component: () => import("@/screens/admin/sales/videos/Layout.vue"),
            children: [
              {
                path: "pending",
                name: "AdminVideoSalesPending",
                component: () =>
                  import("@/screens/admin/sales/videos/Pending.vue")
              },
              {
                path: "processing",
                name: "AdminVideoSalesProcessing",
                component: () =>
                  import("@/screens/admin/sales/videos/Processing.vue")
              },
              {
                path: "completed",
                name: "AdminVideoSalesComplete",
                component: () =>
                  import("@/screens/admin/sales/videos/Complete.vue")
              },
              {
                path: "deleted",
                name: "AdminVideoSalesDeleted",
                component: () =>
                  import("@/screens/admin/sales/videos/Deleted.vue")
              },
              {
                path: "search",
                name: "AdminVideoSalesSearch",
                component: () =>
                  import("@/screens/admin/sales/videos/Search.vue")
              }
            ]
          },
          {
            path: "streams",
            name: "AdminStreamSalesLayout",
            component: () => import("@/screens/admin/sales/Streams.vue")
          }
        ]
      },

      // {
      //   path: "sales/search",
      //   name: "AdminSalesSearch",
      //   beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
      //   component: AdminVideoSearchSale
      // },
      // {
      //   path: "sales/pending",
      //   name: "AdminSalesPending",
      //   beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
      //   component: AdminVideoSalesPending
      // },
      // {
      //   path: "sales/processing",
      //   name: "AdminSalesProcessing",
      //   beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
      //   component: AdminVideoSalesProcessing
      // },
      // {
      //   path: "sales/completed",
      //   name: "AdminSalesCompleted",
      //   beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
      //   component: AdminVideoSalesCompleted
      // },
      // {
      //   path: "stream_sales",
      //   name: "AdminStreamSales",
      //   beforeEnter: multiguard([Guard.checkPermissionsSuperAdministrator]),
      //   component: AdminStreamSales
      // },
      {
        path: "tools",
        name: "AdminTools",
        component: () => import("@/screens/admin/tools/AdminTools.vue")
      },
      {
        path: "tools/email-generator",
        name: "MediaMailer",
        component: () => import("@/screens/admin/tools/MediaMailer.vue")
      },
      // {
      //   path: "tools/mail/list",
      //   name: "AdminToolsMailList",
      //   component: AdminToolsMailList
      // },
      // {
      //   path: "tools/mail/:id",
      //   name: "AdminToolsMailItem",
      //   component: AdminToolsMailItem
      // },
      {
        path: "tools/documents/faa",
        name: "AdminFaaDocumentsOverview",
        component: () =>
          import("@/components/admin/tools/FaaDocumentsOverview.vue")
      },
      {
        path: "support/tickets",
        name: "AdminSupportTickets",
        component: () => import("@/screens/admin/support/Tickets.vue")
      },
      {
        path: "support/tickets/:id",
        name: "AdminSupportIndividualTicket",
        component: () => import("@/screens/admin/support/TicketView.vue")
      },
      {
        path: "tools/coveragemap",
        name: "AdminCoverageMap",
        component: () => import("@/components/admin/tools/CoverageMap.vue")
      }
    ]
  },
  {
    path: "/account/finalize",
    component: AccountSetupLayout,
    redirect: "/account/finalize/terms", // to prevent user from landing on blank page
    beforeEnter: multiguard([Guard.auth, Guard.verifyUserNotSuspended]),
    children: [
      {
        path: "terms",
        name: "FinalizeTerms",
        component: () => import("@/components/account-setup/Terms.vue")
      },
      {
        path: "account",
        name: "FinalizeAccount",
        component: () => import("@/components/account-setup/Account.vue")
      },
      {
        path: "about",
        name: "FinalizeAbout",
        component: FinalizeAbout
      },
      {
        path: "social",
        name: "FinalizeSocial",
        component: FinalizeSocial
      },
      {
        path: "complete",
        name: "FinalizeComplete",
        component: FinalizeComplete
      }
    ]
  },
  {
    path: "/changelog",
    name: "ChangeLog",
    component: ChangeLog
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("@/components/general/PrivacyPolicy")
  },
  {
    path: "/metrics",
    name: "Metrics",
    component: Metrics,
    beforeEnter: multiguard([
      Guard.auth,
      Guard.checkPermissionsVideographer,
      Guard.verifyUserNotSuspended,
      Guard.verifyUserAcceptedTerms
    ])
  },
  {
    path: "/media/preview/:videoId/:refId", // id = video id
    name: "MediaPreviewV2",
    component: MediaPreviewV2
  },
  {
    path: "/media/preview/:id", // id = video id
    name: "MediaPreview",
    component: MediaPreview
  },
  {
    path: "/media/stream/:chaserId",
    component: () => import("@/components/media/StreamPlayer.vue"),
    beforeEnter: multiguard([
      Guard.auth,
      Guard.checkPermissionsMedia,
      Guard.verifyUserNotSuspended,
      Guard.verifyUserAcceptedTerms
    ])
  },
  {
    path: "/media",
    component: () => import("@/screens/media/Layout.vue"),
    redirect: "/media/latest", // to prevent user from landing on blank page
    beforeEnter: multiguard([
      Guard.auth,
      Guard.checkPermissionsMedia,
      Guard.verifyUserNotSuspended,
      Guard.verifyUserAcceptedTerms
    ]),
    children: [
      {
        path: "latest",
        name: "MediaLatestContent",
        component: () => import("@/screens/media/Latest.vue")
      },
      {
        path: "search",
        name: "MediaSearchContent",
        component: () => import("@/screens/media/Search.vue")
      },
      {
        path: "content-requests",
        name: "MediaContentRequests",
        component: () => import("@/screens/media/content-requests/Main.vue")
      },
      {
        path: "content-requests/:id",
        name: "MediaContentRequest",
        component: () => import("@/screens/media/content-requests/Request.vue")
      },
      {
        path: "purchases",
        name: "MediaPurchases",
        component: () => import("@/screens/media/Purchased.vue")
      },
      {
        path: "members",
        name: "MediaMembers",
        component: () => import("@/screens/media/Members.vue")
      },
      {
        path: "streams-wall",
        name: "MediaStreams",
        component: () => import("@/components/media/LiveStreamsList.vue")
      },
      {
        path: "hurricane/streams-wall",
        name: "MediaHurricaneStreams",
        component: () => import("@/components/media/MediaHurricaneStreams.vue")
      }
    ]
  },
  {
    path: "/chasers/wall",
    redirect: "/media/streams-wall"
  },
  {
    path: "/components",
    component: () => import("@/screens/general/Components")
  },
  {
    path: "/404",
    component: () => import("@/screens/general/404")
  },
  {
    path: "/suspended",
    component: () => import("@/screens/general/Suspended")
  },
  {
    path: "/email/unsubscribe/:mrId",
    name: "GeneralEmailUnsubscribe",
    component: () => import("@/screens/general/EmailUnsubscribe")
  },
  {
    path: "*",
    redirect: "/404"
  }
];
